import { portalDs } from 'src/components/portal-design-system';
import { cn } from 'src/lib/utils';
import type { UsersTabView } from '../hooks/use-users-tab-url-params';

interface UsersTeamsToggleProps {
  value: UsersTabView;
  onChange: (value: UsersTabView) => void;
}

const OPTIONS: { value: UsersTabView; label: string }[] = [
  { value: 'users', label: 'Users' },
  { value: 'teams', label: 'Teams' },
];

export function UsersTeamsToggle({ value, onChange }: UsersTeamsToggleProps) {
  return (
    <div
      className={portalDs.segmentGroup}
      role="group"
      aria-label="Users or teams view"
    >
      {OPTIONS.map((option) => {
        const isActive = option.value === value;
        return (
          <button
            key={option.value}
            type="button"
            className={cn(portalDs.segment, isActive && portalDs.segmentActive)}
            aria-pressed={isActive}
            onClick={() => onChange(option.value)}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
